import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=2d56e47b&scoped=true&"
import script from "./Data.vue?vue&type=script&lang=js&"
export * from "./Data.vue?vue&type=script&lang=js&"
import style0 from "./Data.vue?vue&type=style&index=0&id=2d56e47b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56e47b",
  null
  
)

export default component.exports